import { styled } from '@mui/material/styles';
import { AppBar, Button, List, ListItemButton, ListItemIcon, ListItemSecondaryAction, ListItemText, Toolbar, Typography } from '@mui/material';

export const StyledDialog = styled('div')({
  '& .MuiDialog-root.notify-modal-dialog': {
    zIndex: `1300 !important`,
  },
});

export const StyledAppBar = styled(AppBar)({
  position: 'relative',
});

export const StyledToolbar = styled(Toolbar)({
  height: 70,
});

export const Title = styled(Typography)({
  margin: 0,
  padding: 0,
  lineHeight: 1.2,
  fontWeight: 'bold',
});

export const Container = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(4),
  width: '80%',
  maxWidth: 600,
  margin: '0 auto',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    padding: 0,
  },
  '& .task-notify-white-icon': {
    color: theme.palette.common.white,
  },
}));

export const NOTIFY_WHITE_ICON = 'task-notify-white-icon';

export const NotifyList = styled(List)(({ theme }) => ({
  '& > li': {
    backgroundColor: theme.palette.action.disabled,
    marginBottom: 3,
  },
}));

export const SelectAll = styled(ListItemButton)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const StyledListItem = styled(ListItemButton)({
  marginBottom: 3,
});

export const AssigneeText = styled('div')(({ theme }) => ({
  color: theme.palette.text.primary,
}));

export const BarTitle = styled('div')(({ theme }) => ({
  flexDirection: 'column',
  flex: 1,
  marginLeft: theme.spacing(2),
}));

export const ButtonWrap = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    marginLeft: theme.spacing(1),
  },
}));

export const ButtonRow = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(2),
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  '& .MuiButton-root + .MuiButton-root': {
    marginLeft: theme.spacing(1),
  },
}));

export const SecondaryAction = styled(ListItemSecondaryAction)(({ theme }) => ({
  height: '100%',
  borderLeft: `solid ${theme.palette.divider} 1px`,
  right: 0,
}));

export const SecondaryButton = styled(Button)(({ theme }) => ({
  height: '100%',
  width: '100%',
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
}));

export const ChildList = styled('div')(({ theme }) => ({
  marginLeft: theme.spacing(2),
}));

export const ImageIconWrap = styled('div')(({ theme }) => ({
  position: 'absolute',
  bottom: 2,
  right: 2,
  color: theme.palette.common.white,
}));

export const CheckboxIcon = styled(ListItemIcon)({
  minWidth: 'inherit',
});
